module.exports = __webpack_public_path__ + "media/images/crossSection-1d927d51ff383a36d14191c52f1f4567.svg";